module.exports = __webpack_public_path__ + "static/img/banner.da3f477.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner.jpg
// module id = xd5X
// module chunks = 0